module.exports = __webpack_public_path__ + "img/20191125164647360截图20191125163031196.881be65a.jpg";